// require('react-datetime');
import React from 'react';
import ItemView from './ItemView';
// import Tools from '../../tools';
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import Enums from '../../enums';
// import Tools from '../../tools';
/*
{
    type: Enums.E_ITEM.TEXT,
    data: {
        label:"暱稱",
        value:tmpObj.info.display_name,
        placeholder: ""
    }
},{
    type: Enums.E_ITEM.TIME,
    data: {
        label:"註冊時間",
        value:tmpObj.created_at
    }
},{
    type: Enums.E_ITEM.NUMBER,
    data: {
        label:"手機",
        value: tmpObj.bind.p.va
    }
}
*/

export default class InputComponent extends React.Component {
    render() {
        const { type, data, isEditable, onUpdate, id } = this.props;
        switch (type) {
            case Enums.E_ITEM.TEXT:
            default:
                return (<InputTextComponent
                    id={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
                break;
            case Enums.E_ITEM.TEXTAREA:
                return (<InputTextareaComponent
                    id={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
                break;
            case Enums.E_ITEM.OPTION:
                return (<InputOptionComponent
                    id={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
                break;
            case Enums.E_ITEM.GENDER:
                return (<InputGenderComponent
                    id={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
            case Enums.E_ITEM.JOB:
                return (<InputJobComponent
                    id={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
            case Enums.E_ITEM.EDU:
                return (<InputEduComponent
                    id={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
            case Enums.E_ITEM.TIME:
                return (<InputTimeComponent
                    id={id}
                    key={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
                break;
            case Enums.E_ITEM.NUMBER:
                return (<InputNumberComponent
                    id={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
                break;
            case Enums.E_ITEM.RADIO:
                return (<InputRadioComponent
                    id={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
                break;
            case Enums.E_ITEM.IMAGE:
                return (<InputImageComponent
                    id={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
            case Enums.E_ITEM.CITY_AREA:
                return (<InputCityAreaComponent
                    id={id}
                    data={data}
                    enabled={isEditable}
                    onUpdate={onUpdate} />);
            case Enums.E_ITEM.EMPTY:
                return (<InputEmptyComponent />);
        }
    }
}

class InputNumberComponent extends React.Component {
    constructor(props) {
        super(props);

        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) {
        const tmp = parseInt(e.target.value);
        this.props.onUpdate(this.props.id, e.target.value);
    }

    render() {
        // const {value} = this.state;
        let { enabled } = this.props;
        let { placeholder, label, neccessary, value, isError } = this.props.data;
        const { onValueChange } = this;
        if (null == enabled) enabled = true;
        return (
            <div className="row">
                <div className={"form-group col " + (isError ? "has-error has-feedback" : "")}>
                    <label className="col control-label">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="">
                        <input type="number"
                            className="form-control"
                            placeholder={placeholder}
                            onChange={onValueChange}
                            disabled={!enabled}
                            value={value} />
                    </div>
                </div>
            </div>
        );
    }
}

class InputOptionComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value || "",
        };
        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) {
        let tmp = e.target.value; //parseInt(e.target.value);
        // console.log(tmp);
        this.props.onUpdate(this.props.id, e.target.value);
    }

    render() {
        let { enabled } = this.props;
        let { value, options, label, neccessary, isError } = this.props.data;
        const { onValueChange } = this;
        const tmp = [];

        if (null == enabled) enabled = true;

        // console.log(options);
        for (let i in options) {
            let op = options[i];
            // console.log(op);
            tmp.push(<option key={op[0]} value={op[0]}>{op[1]}</option>);
        }

        return (
            <div className="row">
                <div className={"form-group col " + (isError ? "has-error has-feedback" : "")}>
                    <label className="col control-label">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="">
                        <select className="form-control"
                            value={value}
                            onChange={onValueChange}
                            disabled={!enabled}
                        >
                            {tmp}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

class InputGenderComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value || "",
        };
        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) {
        let tmp = e.target.value; //parseInt(e.target.value);
        // console.log(tmp);
        this.props.onUpdate(this.props.id, e.target.value);
    }

    render() {
        let { enabled } = this.props;
        let { value, label, neccessary, isError } = this.props.data;
        const { onValueChange } = this;
        const tmp = [];
        const options = Enums.E_GENDER_TEXT;
        if (null == enabled) enabled = true;

        for (let i in options) {
            tmp.push(<option key={i} value={i}>{options[i]}</option>);
        }

        return (
            <div className="row">
                <div className={"form-group col " + (isError ? "has-error has-feedback" : "")}>
                    <label className="col control-label">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="">
                        <select className="form-control"
                            value={value}
                            onChange={onValueChange}
                            disabled={!enabled}
                        >
                            {tmp}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

class InputJobComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value || "",
        };
        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) {
        let tmp = e.target.value; //parseInt(e.target.value);
        // console.log(tmp);
        this.props.onUpdate(this.props.id, e.target.value);
    }

    render() {
        let { enabled } = this.props;
        let { value, label, neccessary, isError } = this.props.data;
        const { onValueChange } = this;
        const tmp = [];
        const options = Enums.E_JOB_TEXT;
        if (null == enabled) enabled = true;

        for (let i in options) {
            tmp.push(<option key={i} value={i}>{options[i]}</option>);
        }

        return (
            <div className="row">
                <div className={"form-group col " + (isError ? "has-error has-feedback" : "")}>
                    <label className="col control-label">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="">
                        <select className="form-control"
                            value={value}
                            onChange={onValueChange}
                            disabled={!enabled}
                        >
                            {tmp}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

class InputEduComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value || "",
        };
        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) {
        let tmp = e.target.value; //parseInt(e.target.value);
        // console.log(tmp);
        this.props.onUpdate(this.props.id, e.target.value);
    }

    render() {
        let { enabled } = this.props;
        let { value, label, neccessary, isError } = this.props.data;
        const { onValueChange } = this;
        const tmp = [];
        const options = Enums.E_EDU_TEXT;
        if (null == enabled) enabled = true;

        for (let i in options) {
            tmp.push(<option key={i} value={i}>{options[i]}</option>);
        }

        return (
            <div className="row">
                <div className={"form-group col " + (isError ? "has-error has-feedback" : "")}>
                    <label className="col control-label">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="">
                        <select className="form-control"
                            value={value}
                            onChange={onValueChange}
                            disabled={!enabled}
                        >
                            {tmp}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

class InputRadioComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value || "",
        };
        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) {
        let tmp = e.target.value; //parseInt(e.target.value);
        // console.log(tmp);
        this.props.onUpdate(this.props.id, e.target.value);
    }

    render() {
        let { enabled, id } = this.props;
        let { value, options, label, neccessary, isError } = this.props.data;
        const { onValueChange } = this;
        const tmp = [];

        if (null == enabled) enabled = true;

        // console.log(options);
        for (let i in options) {
            let op = options[i];
            // console.log(op);
            if (op[0] == value) {
                tmp.push(<div key={i} className="radio"><label><input type="radio" name={"ra_" + id} key={op[0]} value={op[0]} disabled={!enabled} onClick={onValueChange} defaultChecked="true" />{op[1]}&nbsp;</label></div>);
            } else {
                tmp.push(<div key={i} className="radio"><label><input type="radio" name={"ra_" + id} key={op[0]} value={op[0]} disabled={!enabled} onClick={onValueChange} />{op[1]}&nbsp;</label></div>);
            }
        }

        return (
            <div className="row">
                <div className={"form-group col " + (isError ? "has-error has-feedback" : "")}>
                    <label className="col control-label">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="col form-check form-check-inline">
                        {tmp}
                    </div>
                </div>
            </div>
        );
    }
}

class InputTextareaComponent extends React.Component {
    constructor(props) {
        super(props);

        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) {
        const tmp = parseInt(e.target.value);
        this.props.onUpdate(this.props.id, e.target.value);
    }

    render() {
        // const {value} = this.state;
        let { enabled } = this.props;
        let { placeholder, label, neccessary, value, isError } = this.props.data;
        const { onValueChange } = this;
        if (null == enabled) enabled = true;
        return (
            <div className="row">
                <div className={"form-group col " + (isError ? "has-error has-feedback" : "")}>
                    <label className="col control-label">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="">
                        <textarea type="text"
                            className="form-control"
                            placeholder={placeholder}
                            onChange={onValueChange}
                            disabled={!enabled}
                            value={value} />
                    </div>
                </div>
            </div>
        );
    }
}

class InputTextComponent extends React.Component {
    constructor(props) {
        super(props);

        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) {
        const tmp = parseInt(e.target.value);
        this.props.onUpdate(this.props.id, e.target.value);
    }

    render() {
        // const {value} = this.state;
        let { enabled } = this.props;
        let { placeholder, label, neccessary, value, isError } = this.props.data;
        const { onValueChange } = this;
        if (null == enabled) enabled = true;
        return (
            <div className="row">
                <div className={"form-group col " + (isError ? "has-error has-feedback" : "")}>
                    <label className="col control-label">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="">
                        <input type="text"
                            className="form-control"
                            placeholder={placeholder}
                            onChange={onValueChange}
                            disabled={!enabled}
                            value={value} />
                    </div>
                </div>
            </div>
        );
    }
}

class InputTimeComponent extends React.Component {
    constructor(props) {
        super(props);

        // this.props.data.value = parseInt(this.props.data.value);
        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) {
        // console.log(e, e.unix());
        try {
            this.props.onUpdate(this.props.id, e.unix() * 1000);
        } catch (e) {
            // alert("請輸入日期");
        }
    }

    render() {
        // const {value} = this.state;
        let { enabled } = this.props;
        let { onValueChange } = this;
        let { label, neccessary, value, isError } = this.props.data;
        let time = parseInt(value);
        // console.log(time);
        // const {onValueChange} = this;
        if (null == enabled) enabled = true;
        return (
            <div className="row">
                <div className={"form-group col " + (isError ? "has-error has-feedback" : "")}>
                    <label className="col control-label">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className=''>
                        <DateTime onChange={onValueChange}
                            // disabled={!enabled}
                            dateFormat="YYYY/MM/DD"
                            timeFormat={false}
                            value={time}
                            inputProps={{ disabled: !enabled }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

class InputImageComponent extends React.Component {
    constructor(props) {
        super(props);

        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(e) {
        const tmp = parseInt(e.target.value);
        this.props.onUpdate(this.props.id, e.target.value);
    }

    render() {
        // const {value} = this.state;
        let { enabled } = this.props;
        let { placeholder, label, neccessary, value, isError } = this.props.data;
        const { onValueChange } = this;
        if (null == enabled) enabled = true;
        return (
            <div className="row">
                <div className={"form-group col " + (isError ? "has-error has-feedback" : "")}>
                    <label className="col control-label">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="">
                        <input type="text"
                            className="form-control"
                            placeholder={placeholder}
                            onChange={onValueChange}
                            disabled={!enabled}
                            value={value} />
                    </div>
                    <div className="col form-control-img-container"><img src={value} /></div>
                </div>
            </div>
        );
    }
}

class InputEmptyComponent extends React.Component {
    render() {
        return (
            <div className="row">
                <div className={"form-group col "}>
                </div>
            </div>
        );
    }
}

class InputCityAreaComponent extends React.Component {
    constructor(props) {
        super(props);

        // console.log(this.props);
        this.state = {
            city: this.props.data.value.city || "",
            area: this.props.data.value.area || "",
        };
        this.onCityChange = this.onCityChange.bind(this);
        this.onAreaChange = this.onAreaChange.bind(this);
    }

    onCityChange(e) {
        let tmp = e.target.value; //parseInt(e.target.value);
        // console.log(tmp);
        this.props.onUpdate(this.props.id, { city: e.target.value, area: this.props.data.value.area });
    }
    onAreaChange(e) {
        let tmp = e.target.value; //parseInt(e.target.value);
        // console.log(tmp);
        this.props.onUpdate(this.props.id, { city: this.props.data.value.city, area: e.target.value });
    }

    render() {
        let { enabled, id } = this.props;
        let { value, label, neccessary, isError } = this.props.data;
        let { city, area } = value;
        // console.log(city,area);
        const { onCityChange, onAreaChange } = this;
        if (null == enabled) enabled = true;
        const cities = [];
        const eCity = Enums.E_CITY_TEXT;
        for (let i in eCity) {
            cities.push(<option key={id + "-c-" + i} value={i}>{eCity[i]}</option>);
        }
        const eArea = Enums.E_AREA_TEXT;
        const areas = [];
        const eCityArea = Enums.E_CITY_AREA[city];
        // console.log(eCityArea);
        for (let i in eCityArea) {
            // for (let i=0; i<eCityArea.length; i++) {
            var areaTmp = eCityArea[i];
            // console.log(areaTmp, eArea[areaTmp]);
            areas.push(<option key={id + "-a-" + areaTmp} value={areaTmp}>{eArea[areaTmp]}</option>);
        }

        return (
            <div className="form-row">
                <div className={"form-group col-6 " + (isError ? "has-error has-feedback" : "")}>
                    <label className="">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="">
                        <select className="form-control"
                            value={city}
                            onChange={onCityChange}
                            disabled={!enabled}
                        >
                            {cities}
                        </select>
                    </div>
                </div>
                <div className={"form-group col-6 " + (isError ? "has-error has-feedback" : "")}>
                    <label className="">{(neccessary ? label + "*" : label)}&nbsp;</label>
                    <div className="">
                        <select className="form-control"
                            value={area}
                            onChange={onAreaChange}
                            disabled={!enabled}
                        >
                            {areas}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}